import React from "react";
import moment from "moment";

function ChatMessage({ item, renderSenderLabel, currentUserId }) {
  const isMine =
    currentUserId &&
    item.senderId &&
    String(item.senderId) === String(currentUserId);

  // CEO + CTO rule: viewer's own messages on the right with blue background,
  // other person's messages on the left with green background.
  const bubbleColor = isMine ? "#0084ff" : "#28a745";
  const textColor = "#ffffff";
  const senderLabel = renderSenderLabel(item);

  return (
    <div
      className="chat-message"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: isMine ? "flex-end" : "flex-start",
        marginBottom: "0.5rem",
      }}
    >
      <div
        style={{
          textAlign: "center",
          marginBottom: "0.1rem",
        }}
      >
        <div
          style={{
            fontSize: "0.8rem",
            fontWeight: "bold",
            color: "#666",
          }}
        >
          {senderLabel} on {moment
            .utc(item.createdAt)
            .local()
            .format("MMM D, h:mm A")}
        </div>
      </div>
      <div
        style={{
          maxWidth: "45%",
          backgroundColor: bubbleColor,
          color: textColor,
          padding: "0.5rem 0.75rem",
          borderRadius: "1rem",
          borderBottomRightRadius: isMine ? "0.25rem" : "1rem",
          borderBottomLeftRadius: isMine ? "1rem" : "0.25rem",
          wordWrap: "break-word",
          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ fontSize: "0.9rem" }}>
          {item.text}
        </div>
      </div>
    </div>
  );
}

export default ChatMessage;
